import { render, staticRenderFns } from "./Ab.vue?vue&type=template&id=70a45c20"
import script from "./Ab.vue?vue&type=script&lang=ts"
export * from "./Ab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports